export const styles = {
  containerSmallSpinner: {
    display: "flex",
    justifyContent: "center",
    marginTop: "150px",
    marginBottom: "150px",
  },
};
